import { language } from "@chef/constants";

export const addressQueryCountry = (
  {
    dk: "dnk",
    no: "nor",
    se: "swe",
  } as const
)[language];

export const intl = (
  {
    no: {
      ACTIVE_ADDRESS: "Aktiv adresse",
      ALL_ADDRESSES: "Alle adresser",
      ADD_NEW_ADDRESS: "Legg til ny adresse",
      YOU_CAN_ADD_AND_SAVE_MULTIPLE_ADDRESSES:
        "Du kan legge til og lagre flere forskjellige adresser.",
      INSTRUCTIONS_TO_DRIVER: "Beskjed til sjåfør",
      DELIVERY_DAY_AND_INTERVAL: "Leveringsdato og intervall",
      CHANGE_ACTIVE_ADDRESS: "Endre aktiv adresse og leveringstid",
      EDIT_ADDRESS: "Rediger",
      INACTIVE_ADDRESS_TEXT: "Du kan redigere adressen, når den er aktiv.",
      ADD_ADDRESS_BUTTON: "Legg til ny adresse",
      ONGOING_DELIVERY_DISCLAIMER:
        "Du har en levering på vei til denne adressen den",
      NEXT_DELIVERY_DISCLAIMER: "Levering til denne adresse trer i kraft den",
      ERROR_UPDATING_ADDRESS:
        "Det skjedde en feil under valideringen av din adresse. Prøv igjen.",
      COMPLETE_YOUR_ADDRESS_DETAILS:
        "Registrer leilighetsnummer for en bedre leveringsopplevelse",
      ADD_APARTMENT_DETAILS: "Legg til leilighetsnummer",
      FLOOR: "Etasje",
      DELIVERY_INFORMATION_TITLE: "Leveringsinformasjon",
    },

    se: {
      ACTIVE_ADDRESS: "Aktiv adress",
      ALL_ADDRESSES: "Alla dina adresser",
      ADD_NEW_ADDRESS: "Lägg till ny adress",
      YOU_CAN_ADD_AND_SAVE_MULTIPLE_ADDRESSES:
        "Du kan lägga till och spara flera adresser",
      INSTRUCTIONS_TO_DRIVER: "Instruktioner till chauffören",
      DELIVERY_DAY_AND_INTERVAL: "Leveransdag och intervall",
      CHANGE_ACTIVE_ADDRESS: "Ändra aktiv adress och leveranstid",
      EDIT_ADDRESS: "Redigera",
      INACTIVE_ADDRESS_TEXT: "Du kan redigera adressen när den är aktiv.",
      ADD_ADDRESS_BUTTON: "Lägg till en ny adress",
      ONGOING_DELIVERY_DISCLAIMER:
        "Du har en leverans på väg till denna adress",
      NEXT_DELIVERY_DISCLAIMER: "Adressen börjar gälla den",
      ERROR_UPDATING_ADDRESS: "Kunde inte uppdatera adressen",
      COMPLETE_YOUR_ADDRESS_DETAILS:
        "Komplettera dina adressuppgifter för en bättre leveransupplevelse.",
      ADD_APARTMENT_DETAILS: "Lägg till lägenhetsnummer.",
      FLOOR: "Våning",
      DELIVERY_INFORMATION_TITLE: "Leveransuppgifter",
    },
    dk: {
      ACTIVE_ADDRESS: "Aktiv adresse",
      ALL_ADDRESSES: "Alle adresser",
      ADD_NEW_ADDRESS: "Tilføj ny adresse",
      YOU_CAN_ADD_AND_SAVE_MULTIPLE_ADDRESSES:
        "Du kan tilføje og gemme flere forskellige adresser.",
      INSTRUCTIONS_TO_DRIVER: "Besked til chauffør",
      DELIVERY_DAY_AND_INTERVAL: "Leveringsdato og interval",
      CHANGE_ACTIVE_ADDRESS: "Ændr aktiv adresse og leveringstid",
      EDIT_ADDRESS: "Rediger",
      INACTIVE_ADDRESS_TEXT: "Du kan redigere adressen, når den er aktiv.",
      ADD_ADDRESS_BUTTON: "Tilføj ny adresse",
      ONGOING_DELIVERY_DISCLAIMER:
        "Du har en levering på vei til denne adresse den",
      NEXT_DELIVERY_DISCLAIMER: "Levering til denne adresse træder i kraft den",
      ERROR_UPDATING_ADDRESS:
        "Der skete en fejl under valideringen af din adresse. Prøv igen.",
      COMPLETE_YOUR_ADDRESS_DETAILS:
        "Angiv lejlighedsnummer for en bedre leveringsoplevelse",
      ADD_APARTMENT_DETAILS: "Tilføj lejlighedsnummer",
      FLOOR: "Etage",
      DELIVERY_INFORMATION_TITLE: "Leveringsoplysninger",
    },
  } as const
)[language];
